import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormLabel from '../../../library/form/components/FormLabel'
import FormROValue from '../../../library/form/components/FormROValue1';

const ProQV = (props) => {
    const { formObject } = props;

    return (
        <div>
            <ul className="uiFormMini uiPopupItem">
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiHighlightKey'/>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priority" }} />
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "relationWith" }} value="Account Owner" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "relationWith" }} />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "company" }} value="Account Name" />:
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "company" }} />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Address" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "address" }} />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "contact" }} value="Contact Person" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "contact" }} />
                </li>
                <li>
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile" }} value="Mobile" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "mobile" }} />
                </li>
                <li>
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email" }} value="Email" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "email" }} />
                </li>
            </ul>
        </div>
    )
}

export default withView(ProQV, "proQV", "");